import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Orange_Btn from "../../../common/buttons/orange_btn/Orange_Btn";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import { getUserQr } from "../../../features/admin/whatsapp/qr/qrSlice";
import { useDispatch } from "react-redux";
import { ReplyMessageAction } from "../../../features/admin/whatsapp/message/slice";
import ModelLoader from "../../../common/loader/ModelLoader";

const Reply_Modal = ({
  show,
  showSuccess,
  setShowSuccess,
  setShowError,
  message,
  setErrorMessage,
  onHide,

}) => {
  const dispatch = useDispatch();

  const [instanceValue, setInstanceValue] = useState([]);
  const [loader, setLoader] = useState(false);
  const [title, setTitle] = useState("");

  const options = [instanceValue];
  useEffect(() => {
    setInstance()
  }, [dispatch])

  const setInstance = async () => {
    const res = await dispatch(getUserQr());
    const data = res?.payload?.data?.data;


    if (Array.isArray(data) && data.length > 0) {
      const options = data?.map((item) => ({
        name: 'instance_key',
        value: item?.instance_key,
        label: `${item?.instance_key} -> WP NO : ${item?.contact_no ?? "N/A"} (${item?.instance_status ? "ACTIVE" : "IN-ACTIVE"})`
      }));

      setInstanceValue(options); // sets array of all instances
    }
  };



  const {
    control,
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  const handleReply = async (data) => {
    setLoader(true);
    setTitle("Sending Reply Message...");

    const sendData = new FormData();

    // Basic fields
    sendData.append("instance_key", data?.instance_key?.value || "");
    sendData.append("message", data?.message || "");

    // Media file
    if (data?.media_file && data.media_file.length > 0) {
      sendData.append("media_file", data.media_file[0]);
      sendData.append("combination_id", 2 || "");
    } else {
      sendData.append("combination_id", 1 || "");
    }


    try {
      // Example dispatch:
      const res = await dispatch(ReplyMessageAction({ id: message?.id, data: sendData }));
      console.log(res, ";;;;;;;");

      if (res.meta?.requestStatus === "fulfilled") {
        setLoader(false);
        setTitle("");
        setShowSuccess(true);
        setShowError(false);
        // reset()
        onHide()
        // await dispatch(dashboard())
      } else if (res.meta?.requestStatus === "rejected") {
        setLoader(false);
        setTitle("");
        setErrorMessage(res.payload?.errors || "Something went wrong");
        setShowError(true);
        setShowSuccess(false);
      }


    } catch (error) {
      console.error("Error sending message:", error);
    }

  }

  return (
    <Modal className="reply_modal" show={show} onHide={() => onHide()}>
      <Modal.Header closeButton>
        <Modal.Title>Reply To {message?.name} ({message?.from_sent})</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="input_group common_form_group">
            <Form.Label>Select Instance From Below List</Form.Label>
            <Controller
              name="instance_key" // name of the field
              defaultValue={{ value: 0, label: "---Select Instance---" }}
              {...register("instance_key", {
                required: "Select Instance",
              })}
              control={control}
              render={({ field }) => (
                <Select
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      borderColor: errors.instance_key
                        ? "red"
                        : baseStyles,
                    }),
                  }}
                  {...field}
                  options={instanceValue}
                />
              )}
            />
            {errors?.instance_key && (
              <Form.Text className="text-danger">{errors?.instance_key?.message}</Form.Text>
            )}
          </Form.Group>

          {/* <Form.Group className="input_group common_form_group">
            <Form.Control
              placeholder="Enter Number with Country Code"
              type="text"
              {...register("to_sent", {
                required: "Number is required",
                maxLength: {
                  value: 100,
                  message: "Number cannot exceed 100 characters",
                },
              })}
            />
            {errors?.to_sent && (
              <Form.Text className="text-danger">{errors?.to_sent?.message}</Form.Text>
            )}
          </Form.Group> */}

          <Form.Group className="input_group common_form_group">
            <Form.Control
              placeholder="Enter Message"
              type="text"
              {...register("message", {
                required: "Message is required",
                maxLength: {
                  value: 100,
                  message: "Message cannot exceed 100 characters",
                },
              })}
            />
            {errors?.message && (
              <Form.Text className="text-danger">{errors?.message?.message}</Form.Text>
            )}
          </Form.Group>


          <Form.Group className="input_group common_form_group">
            <Form.Control
              placeholder="Enter Message"
              type="file"
              {...register("media_file", {
                validate: {
                  fileSize: (fileList) =>
                    !fileList[0] || fileList[0].size <= 1 * 1024 * 1024 || "Max file size is 1MB",
                  fileType: (fileList) =>
                    !fileList[0] ||
                    ['image/jpeg', 'image/png', 'image/gif', 'application/pdf', 'audio/mpeg', 'video/mp4'].includes(fileList[0].type) ||
                    "Unsupported file type",
                },
              })}
              accept="image/jpeg,image/png,image/gif,application/pdf,audio/mpeg,video/mp4"
            />

            {errors?.media_file && (
              <Form.Text className="text-danger">{errors?.media_file?.message}</Form.Text>
            )}
          </Form.Group>

          <div className="send_btn_holder">
            <Orange_Btn btnText={"Quick Send"} icon={faPaperPlane}
              onClick={handleSubmit(handleReply)}
            //  onClick={
            //   () => { setShow(true) }
            //   }
            />
          </div>
        </Form>
      </Modal.Body>

      <ModelLoader show={loader} setShow={setLoader} title={title} />
    </Modal>
  );
};

export default Reply_Modal;
